import React from 'react'
import { useEffect, useState } from "react";
import GetIcon from "../../../../utils/Icon";
import { useNavigate } from 'react-router-dom';
import printerimg from "../../../../assets/print.png"
import Button from "../../../../Core/Button/Button";
import FormLayoutTwo from "../../../../Core/Layout/FormLayoutTwo";
import { useGetBrandByNameQuery, useUpdateBrandMutation } from '../../../../store/api/barand_master';
import ApiResponseBox from '../../../../Components/ApiResponseBox';
import Tab1 from "./Tab1";
import { useLocation } from 'react-router-dom';
import Attachment from '../../../../utils/Attachment';
import { usePageState } from "../../../../Hook/usePageState";
import { isStateChanged } from "../../../../utils/stateComparator";
function Brand() {
  const navigate = useNavigate()
  const location = useLocation()
  const brandName = location?.state.PurchaseId
  // const [tab, settab] = useState(1)
  const [res, setRes] = useState(false)
  // const [brand, setBrand] = useState('');
  // const [description, setDescription] = useState('');
  const [error, setError] = useState('');
  const [ptype, setptype] = useState("Error")
  const [showError, setShowError] = useState(false);
  const { data, isLoading } = useGetBrandByNameQuery(brandName);
  const [updateBrand] = useUpdateBrandMutation();

const [fieldErrors, setFieldErrors] = useState({
      brand: '',
      description: ''
    });

  const pageStateDefault = {
        tab: 1,
        brand:'',
        description:''
      };
      
          const [pageState, setPageState] = usePageState(`Edit Brand - ${brandName}`, pageStateDefault);
    
    
      const { tab,brand,description } = pageState;

useEffect(() => {
   if (!isStateChanged(pageState, pageStateDefault)) {
  if (data?.data) {
    setPageState({ ...pageState, brand: data.data.name || '', description:data.data.description || '' })
  }
}
}, [data]);

  const handleSubmit = async () => {
    const payload = { brand, description };
    try {
      const res = await updateBrand({ brandName, data: payload }).unwrap();
      setError('Brand updated successfully!');
      setTimeout(() => {
        navigate('/master/brand/brand-list')
      }, 3000);
      setptype('Success');
      setShowError(true);
    } catch (err) {
      setError(err?.data?.message || 'Failed to create brand. Brand name may already exist.');
      setptype('Error');
      setShowError(true);
    }
  };
  return (
    <>
      <FormLayoutTwo
        title="Edit Brand"
        breadcrumbs={[
          { label: "Brand" },
          { label: "Brand List", url: "/master/brand/brand-list" }
        ]}
        status={'hide'}
        actionButtons={
          <>
            <Button
              className="custom-btn-00989"
              iconName="LuFilePlus2"
              style={{ gap: '2px', height: '28px' }}
              onClick={handleSubmit}
              iconSize={12}
            >
              Update
            </Button>
            <Button
              to="/brand/create-brand"
              className="px-2"
              imgSrc={printerimg}
              imgStyle={{ width: '21px' }}
            />
          </>
        }
      >
        <div className="" style={{ width: "100%", overflow: "hidden", backgroundColor: "#fff", flexGrow: '1' }}>
          <div className="col-12 p-0" style={{ backgroundColor: '#eff4f9' }}>
            <div className="d-flex justify-content-between align-items-end ">
              <ul className="nav nav-tabs" style={{ color: "white", border: "none" }}>
                <li className="nav-item-tab-custom d-flex pb-0 align-items-end border-radius-top-corner" >
                  <a className={tab == 1 ? "removeborder234 nav-link active-tab-custom text-white border-radius-top-corner" : "removeborder234 nav-link nav-link-tab-custom bg-white border-radius-top-corner"} onClick={() => { setPageState({ ...pageState, tab: 1 }) }} href="javascript:void(0);">
                    General Details{tab == 1 ? <GetIcon iconName="MdKeyboardArrowDown" size={15} /> : <GetIcon iconName="MdKeyboardArrowRight" size={15} />}
                  </a>
                </li>
              </ul>
              {/* <div className="d-flex align-items-center mb-2 px-3" style={{ gap: "2px", fontSize: '12px' }}>
                <span style={{ position: 'relative', top: '-1px' }}>
                  <GetIcon iconName="CgAttachment" size={12} />
                </span>
                <span className=" fw-semibold" style={{ color: "#391F84" }}>
                  Attachments
                </span>
              </div> */}
                          <Attachment doctype="Brand"  docname={brandName}  /> 
              
            </div>
          </div>
           <div className=" " style={{ background: '' }}>
                    <div className="row">
                      <div className="col-12">
                        <div >
                         <Tab1 
                     brand={{
                       value: pageState.brand,
                       setValue: (val) => setPageState({ ...pageState, brand: val }),
                       error: fieldErrors.brand,
                     }}
                     description={{
                       value: pageState.description,
                       setValue: (val) => setPageState({ ...pageState, description: val }),
                       error: fieldErrors.description,
                     }}
                   />
                        </div>
                      </div>
                    </div>
                  </div> 
        
        </div>
        <ApiResponseBox
          poptype={ptype}
          show={showError}
          errorMessage={error}
          onClose={() => setShowError(false)}
        />
      </FormLayoutTwo>
    </>
  )
}

export default Brand
